export const CompanyLogos = {
    renaissance: require(`@/assets/img/logo/rennaisance.png`),
    ingostrah: require(`@/assets/img/logo/ingostrah.png`),
    soglasie: require(`@/assets/img/logo/soglasie.png`),
    tinkoff: require(`@/assets/img/logo/tinkoff.png`),
    ugoria: require(`@/assets/img/logo/ugoria.png`),
    zetta: require(`@/assets/img/logo/zetta.png`),
    alfa: require(`@/assets/img/logo/alfa.png`),
    makc: require(`@/assets/img/logo/makc.png`),
    reso: require(`@/assets/img/logo/reso.png`),
    sngi: require(`@/assets/img/logo/sngi.png`),
    rgs: require(`@/assets/img/logo/rgs.png`),
    vsk: require(`@/assets/img/logo/vsk.png`),
    mafin: require(`@/assets/img/logo/mafin.png`),
    guideh: require(`@/assets/img/logo/guideh.png`),
    sogaz: require(`@/assets/img/logo/sogaz.png`),
    astrovolga: require(`@/assets/img/logo/astrovolga.png`),
    verna: require(`@/assets/img/logo/verna.png`),
    euroins: require(`@/assets/img/logo/euroins.png`),
    gelios: require(`@/assets/img/logo/gelios.png`),
    sber: require(`@/assets/img/logo/sber.png`),
    spasgates: require('@/assets/img/logo/spasgates.png'),
    sovkombank: require('@/assets/img/logo/sovkombank.png'),
    absolut: require('@/assets/img/logo/absolut.png'),
    energogarant: require('@/assets/img/logo/energogarant.png'),
    pari: require('@/assets/img/logo/pari.png'),
};
